import reducerRegistry from '@comeon/reducer-registry';
import { requestApi, parseResponse } from '~/services/api.js';
import { getCookies, setCookie, COOKIE_CATEGORY, COOKIE_NECESSARY } from '../../../store/cookies.js';
import store from '../../../store/store.js';
import * as CONSTANTS from './constants.js';
import REDUCER_NAME from './reducer-name.js';

const host = '/';

function showCookieSettings() {
	return dispatch => dispatch({ type: CONSTANTS.SHOW_COOKIE_SETTINGS });
}

function hideCookieSettings() {
	return dispatch => dispatch({ type: CONSTANTS.HIDE_COOKIE_SETTINGS });
}

function showCookieBanner() {
	return dispatch => dispatch({ type: CONSTANTS.SHOW_COOKIE_BANNER });
}

function hideCookieBanner() {
	return dispatch => dispatch({ type: CONSTANTS.HIDE_COOKIE_BANNER });
}

function setCookies() {
	return dispatch => dispatch({ type: CONSTANTS.SET_COOKIES });
}

const cookies = () => JSON.parse(getCookies(COOKIE_CATEGORY));

function checkCookiePermission(cookie) {
	return cookies() && cookies()[cookie];
}

function shouldShowCookieBanner() {
	const hasCookie = cookies();
	const hasNecessary = cookies() && cookies()[COOKIE_NECESSARY];
	const showSettings = store.getState().cookieBanner.displayCookieSettings;

	if ((!hasCookie || !hasNecessary) && !showSettings) {
		return showCookieBanner();
	}

	return hideCookieBanner();
}

function addCookiePermission(cookie) {
	if (!checkCookiePermission(cookie)) {
		const cookieValue = cookies() ? { ...cookies(), [cookie]: true } : { [cookie]: true };
		setCookie(COOKIE_CATEGORY, JSON.stringify(cookieValue));
	}
}

function sendDLEvent(cookieConsentValues) {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: 'Cookie_Consent',
		...cookieConsentValues
	});
}

function acceptAllCookies() {
	const cookieConsentValues = {
		[COOKIE_NECESSARY]: 'true'
	};
	addCookiePermission(COOKIE_NECESSARY);
	const { cookieCategories } = store.getState().cookieBanner;
	cookieCategories.forEach(cookie => {
		addCookiePermission(cookie.id);
		cookieConsentValues[cookie.id] = 'true';
	});
	sendDLEvent(cookieConsentValues);
	return hideCookieBanner();
}

export const updateCategories = payload => ({
	type: CONSTANTS.COOKIE_CATEGORIES_UPDATED,
	payload
});

const fetchCookieCategories = () => {
	return async dispatch => {
		try {
			const url = `${host}rest/state/cookiebanner`;
			const response = parseResponse(await requestApi(url));
			return dispatch(
				updateCategories(response.CookieBanner.categories.filter(cookie => cookie.id !== COOKIE_NECESSARY))
			);
		} catch (err) {}
	};
};

const initialState = {
	displayCookieSettings: false,
	displayCookieBanner: false,
	isCookieSet: false,
	cookieCategories: []
};

function reducer(state = initialState, { type, payload }) {
	switch (type) {
		case CONSTANTS.SHOW_COOKIE_SETTINGS:
			return {
				...state,
				displayCookieSettings: true
			};
		case CONSTANTS.HIDE_COOKIE_SETTINGS:
			return {
				...state,
				displayCookieSettings: false
			};
		case CONSTANTS.SHOW_COOKIE_BANNER:
			return {
				...state,
				displayCookieBanner: true
			};
		case CONSTANTS.HIDE_COOKIE_BANNER:
			return {
				...state,
				displayCookieBanner: false
			};
		case CONSTANTS.SET_COOKIES:
			return {
				...state,
				isCookieSet: true
			};
		case CONSTANTS.COOKIE_CATEGORIES_UPDATED:
			return { ...state, cookieCategories: payload };
		default:
			return state;
	}
}

export {
	initialState,
	showCookieSettings,
	hideCookieSettings,
	showCookieBanner,
	hideCookieBanner,
	checkCookiePermission,
	acceptAllCookies,
	sendDLEvent,
	shouldShowCookieBanner,
	setCookies,
	fetchCookieCategories
};

reducerRegistry.register(REDUCER_NAME, reducer);

export default reducer;
